import { BrowserView, MobileView } from "react-device-detect";
import MedicalRecordDetailReportMobile from "./medicalRecordDetailReportMobile";
import MedicalRecordDetailReportWeb from "./medicalRecordDetailReportWeb";
export const MedicalRecordReport = () => {
  return (
    <>
      <MobileView>
        <MedicalRecordDetailReportMobile />
      </MobileView>
      <BrowserView>
        <MedicalRecordDetailReportWeb />
      </BrowserView>
    </>
  );
};

export default MedicalRecordReport;
